import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Trash2, Plus } from 'lucide-react';

import TextInput from '../../components/ui/TextInput.jsx';
import Button from '../../components/ui/Button';

// P1 Görev Paketi A — ölçülebilir PIP hedefi editörü. Hem "Yeni PIP" modalında
// hem detay drawer'ının taslak/aktif düzenlemesinde kullanılır. Kontrollü
// bileşen: goals=[{title, successCriteria}], onChange(yeniListe).
const GoalRow = styled.div`
  display: flex;
  gap: 10px;
  align-items: flex-start;
  margin-bottom: 12px;
`;

const GoalFields = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const RemoveButton = styled.button`
  background: none;
  border: none;
  color: ${({ theme }) => theme.colors.auxiliar?.danger || '#DC2626'};
  cursor: pointer;
  padding: 8px 4px 0;
  &:disabled { opacity: 0.4; cursor: default; }
`;

const EmptyHint = styled.div`
  font-size: ${({ theme }) => theme.metrics.font.size.sm};
  color: ${({ theme }) => theme.colors.text.dark.little};
  margin-bottom: 12px;
`;

export default function PipGoalsEditor({ goals, onChange, disabled = false }) {
  const { t } = useTranslation();

  const updateGoal = (index, patch) => {
    const next = goals.map((g, i) => (i === index ? { ...g, ...patch } : g));
    onChange(next);
  };

  const removeGoal = (index) => {
    onChange(goals.filter((_, i) => i !== index));
  };

  const addGoal = () => {
    onChange([...goals, { title: '', successCriteria: '' }]);
  };

  return (
    <div>
      {goals.length === 0 && <EmptyHint>{t('performance.pip.noGoalsHint')}</EmptyHint>}

      {goals.map((goal, index) => (
        // Sıra indexiyle key — satırlar yalnız ekle/sil ile değişir, reorder yok.
        // eslint-disable-next-line react/no-array-index-key
        <GoalRow key={index}>
          <GoalFields>
            <TextInput
              label={t('performance.pip.goalTitle')}
              value={goal.title}
              onChange={(e) => updateGoal(index, { title: e.target.value })}
              required
              disabled={disabled}
            />
            <TextInput
              label={t('performance.pip.successCriteria')}
              value={goal.successCriteria || ''}
              onChange={(e) => updateGoal(index, { successCriteria: e.target.value })}
              disabled={disabled}
            />
          </GoalFields>
          {!disabled && (
            <RemoveButton
              type="button"
              onClick={() => removeGoal(index)}
              aria-label={t('performance.pip.removeGoal')}
            >
              <Trash2 size={16} />
            </RemoveButton>
          )}
        </GoalRow>
      ))}

      {!disabled && (
        <Button variant="outline" type="button" onClick={addGoal}>
          <Plus size={14} style={{ marginRight: 6 }} />
          {t('performance.pip.addGoal')}
        </Button>
      )}
    </div>
  );
}
